import React from "react";
import { Card } from "../../../types";

const CardItemSmall = ({
	brand,
	last4,
	extraClass = "",
	value,
}: {
	brand: string;
	last4: string;
	extraClass?: string;
	value?: Card;
}) => (
	<div className={`item card small ${extraClass}`} data-card-brand={brand.toLowerCase()}>
		<div className="itemImage">
			<div className={`creditCardIcon ${brand.toLowerCase()}`} data-card-brand={brand.toLowerCase()} />
		</div>
		<div className="itemBody">
			<div className="cardNumber">•••• {last4}</div>
		</div>
	</div>
);

export default CardItemSmall;
